import { SubmitHandler, useForm } from 'react-hook-form'
import * as Yup from 'yup'

import { yupResolver } from '@hookform/resolvers/yup'
import { STORAGE_KEY } from 'src/constants/app'
import history from 'src/libs/history'
import { PATH } from 'src/pages/video/TemporaryReserveConfirm'
import { PATH as PATH_AUTOMATIC_PLAN } from 'src/pages/automaticPlan'
import addressRequest from 'src/api/requests/address'
import { useAppSelector } from 'src/store'
import { useDispatch } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import uiActions from 'src/store/ui/notification'
import { PHONE_REGEX } from 'src/utils/regex'

export type FormValues = {
  date?: string
  time?: string | null
  phone?: string | null
  phoneos?: string | null
}

export const useSchedule = () => {
  const user = useAppSelector((state) => state.ui.app.authInfo)
  const dispatch = useDispatch()
  const [searchParams] = useSearchParams()
  const menuId = searchParams.get('menu_id') ?? ''

  const defaultValues: FormValues = {
    date: '',
    time: '',
    phone: user?.phone || '',
    phoneos: user?.os_type || '',
  }

  const validationSchema = Yup.object().shape({
    date: Yup.string().required('日付を選択してください。'),
    time: Yup.string().required('時間を選択してください。').nullable(),
    phone: Yup.string()
      .nullable()
      .required('入力してください。')
      .min(10, '携帯番号は10〜11桁で入力してください。')
      .max(11, '携帯番号は10〜11桁で入力してください。')
      .matches(PHONE_REGEX, '電話番号は０から始まる必要があります。'),
    phoneos: Yup.string().required('種類を選択してください。　').nullable(),
  })

  const onSubmit: SubmitHandler<FormValues> = async (data, showPhone) => {
    // pending:true marks this entry as "selected but not yet confirmed via API".
    // verifyOTP uses this flag to distinguish it from the CONFIRMED_RESERVATION
    // entry written by keepFlow.ts (which has no pending field).
    localStorage.setItem(
      STORAGE_KEY.VIDEO_SCHEDULE,
      JSON.stringify({ ...data, pending: true }),
    )
    if (showPhone) {
      var dataUpdatePhone = {
        phone: data?.phone,
        os_type: data?.phoneos,
      }
      await addressRequest
        .updatePhone(dataUpdatePhone)
        .then(() => {
          if (!user?.otp_verified_at) {
            // Forward menu_id so verifyOTP can correctly identify the treatment
            // and route to /video/temporary-reserve-confirm after OTP success.
            const smsAuthPath = menuId
              ? `${PATH_AUTOMATIC_PLAN.SMS_AUTH}?menu_id=${menuId}`
              : PATH_AUTOMATIC_PLAN.SMS_AUTH
            history.push(smsAuthPath)
          } else {
            history.push(PATH)
          }
        })
        .catch((error) => {
          dispatch(
            uiActions.onNotification({
              type: 'error',
              message: error.response.data.errors?.phone
                ? error.response.data.errors?.phone[0]
                : error.response.data.errors?.os_type[0] ||
                  error.response.data.message,
            }),
          )
        })
    } else {
      history.push(PATH)
    }
  }

  const form = useForm<FormValues>({
    defaultValues,
    shouldFocusError: true,
    mode: 'all',
    resolver: yupResolver(validationSchema),
  })

  return {
    form,
    onSubmit,
  }
}
